export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/x3aoDGQPATX11t1VnnUhcK/Mockup_BARBER_INSTRUCTOR_READY.png'
